module.exports = __webpack_public_path__ + "img/plus.efd623e6.svg";